import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { ChargingStationConstant } from "./chargingStationConstant";

const initialState = {
  chargingStationList: [],
  ChargingConnectorDropdownList: [],
  deleteChargingStation: [],
  chargingPointList: [],
  deleteChargingConnectorList: [{}],
  chargingDetailList: [],
  ChargingStationCountList: [],
  chargingStation: {
    isLoading: false,
  },

  VendorSelectWiseList: [],
  VendorSelectWise: {
    isLoading: true,
  },

  ChargingStationSeeAllRequestList: [],
  ChargingStationSeeAllRequest: {
    isLoading: true,
  },
  reqChargingCount: "",
  chargingStationNetwork: [],
};

export const ChargingStationReducers = persistReducer(
  {
    storage,
    key: "chargingStation",
    whitelist: [
      "chargingPointList",
      "chargingDetailList",
      "ChargingStationSeeAllRequestList",
    ],
  },
  (state = initialState, { type, payload }) => {
    switch (type) {
      case ChargingStationConstant.CHARGING_STATION_REQUEST: {
        return {
          ...state,
          chargingStationList: [],
          chargingStation: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.CHARGING_STATION_RESPONSE: {
        return {
          ...state,
          chargingStationList: payload,
          chargingStation: {
            isLoading: false,
          },
        };
      }
      case ChargingStationConstant.CHARGING_STATION_DELETE_REQUEST: {
        return {
          ...state,
          deleteChargingStation: [],
          chargingStation: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.CHARGING_STATION_DELETE_RESPONSE: {
        return {
          ...state,
          deleteChargingStation: payload,
          chargingStation: {
            isLoading: false,
          },
        };
      }
      case ChargingStationConstant.CHARGING_STATION_DETAIL_REQUEST: {
        return {
          ...state,
          chargingDetailList: [],
          chargingStation: {
            isLoading: true,
          },
        };
      }

      case ChargingStationConstant.CHARGING_STATION_DETAIL_RESPONSE: {
        return {
          ...state,
          chargingDetailList: payload,
          chargingStation: {
            isLoading: false,
          },
        };
      }

      //charging point
      case ChargingStationConstant.GET_CHARGING_POINT_REQUEST: {
        return {
          ...state,
          chargingPointList: [],
          chargingStation: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.GET_CHARGING_POINT_RESPONSE: {
        return {
          ...state,
          chargingPointList: payload,
          chargingStation: {
            isLoading: false,
          },
        };
      }

      case ChargingStationConstant.DELETE_CHARGING_CONNECTOR_REQUEST: {
        return {
          ...state,
          deleteChargingConnectorList: [],
          chargingStation: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.DELETE_CHARGING_CONNECTOR_RESPONSE: {
        return {
          ...state,
          deleteChargingConnectorList: payload,
          deleteSuccess: true,

          chargingStation: {
            isLoading: false,
          },
        };
      }

      // vedor select wise

      case ChargingStationConstant.GET_VENDOR_SELECT_WISE_REQUEST: {
        return {
          ...state,
          VendorSelectWiseList: [],
          VendorSelectWise: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.GET_VENDOR_SELECT_WISE_RESPONSE: {
        return {
          ...state,
          VendorSelectWiseList: payload,
          VendorSelectWise: {
            isLoading: false,
          },
        };
      }

      //csc
      case ChargingStationConstant.CHARGING_STATION_COUNT_REQUEST: {
        return {
          ...state,
          ChargingStationCountList: [],
          ChargingStationCount: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.CHARGING_STATION_COUNT_RESPONSE: {
        return {
          ...state,
          ChargingStationCountList: payload,
          reqChargingCount: payload.result.pending_request,
          ChargingStationCount: {
            isLoading: false,
          },
        };
      }

      //see all
      case ChargingStationConstant.CHARGING_SEEALLRES_REQUEST: {
        return {
          ...state,
          ChargingStationSeeAllRequestList: [],
          ChargingStationSeeAllRequest: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.CHARGING_SEEALLRES_RESPONSE: {
        return {
          ...state,
          ChargingStationSeeAllRequestList: payload,
          ChargingStationSeeAllRequest: {
            isLoading: false,
          },
        };
      }
      //connector dropdown
      case ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_REQUEST: {
        return {
          ...state,
          ChargingConnectorDropdownList: [],
          ChargingStationSeeAllRequest: {
            isLoading: true,
          },
        };
      }
      case ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_RESPONSE: {
        return {
          ...state,
          ChargingConnectorDropdownList: payload,
          ChargingStationSeeAllRequest: {
            isLoading: false,
          },
        };
      }

      // charging station network dropdown

      case ChargingStationConstant.CHARGING_STATION_NETWORK_REQUEST: {
        return {
          ...state,
          chargingStationNetwork: [],
        };
      }
      case ChargingStationConstant.CHARGING_STATION_NETWORK_RESPONSE: {
        return {
          ...state,
          chargingStationNetwork: payload,
         
        };
      }

      default:
        return state;
    }
  }
);
